import { Request } from '@/helpers'
import { ENDPOINTS } from '@/data'

const Delete = async (
    categoryId: string,
    Categories: Array<CategoryInterface>,
    SetCategories: Function,
    setDeleting: Function,
    InitNotification: Function
) => {
    setDeleting(categoryId)

    try {
        const { success, message } = await Request({
            path: ENDPOINTS.DELETE_CATEGORY,
            method: 'DELETE',
            body: { categoryId }
        })

        if (success) {
            InitNotification(message)

            const categories = structuredClone(Categories)
            const index = categories?.findIndex(({ _id }) => _id === categoryId)

            categories?.splice(index, 1)
            SetCategories({ Categories: categories })
        }

        else InitNotification(message)
    }

    catch (error) {
        console.error(error)
        InitNotification('Something went wrong while trying to delete your category!')
    }

    finally {
        setDeleting(false)
    }
}

export default Delete
